export enum SocialLoginType {
  Facebook = 'facebook',
  Google = 'google',
}
